export const PROFILE = {
  name: 'Yousef Al-Jarmouzi',
  status: 'Full Stack Engineer @ Teli.ai',
  tagline: "// CS, Whitman College '25 — full stack · data · systems",
  location: 'Based in Southfield, MI',
  bio: "I like taking things apart to see why they work, then putting them back together so they work better. Most of what I know came from shipping something, watching it break, and fixing it until it held. Lately that's meant building a platform from a blank repo and untangling one that nine repos deep had stopped making sense. What really makes me happy is building something from the ground up and understanding it end to end, from the database schema all the way to the screen a user actually touches.",
  email: 'yousufnaji02@gmail.com',
  github: 'YNAL7711',
  githubUrl: 'https://github.com/YNAL7711',
  linkedinUrl: 'https://www.linkedin.com/in/yousefaljarmouzi',
  instagramUrl: 'https://www.instagram.com/yousef_jarmoz/',
  resumeUrl: '/resume.pdf',
  photo: '/images/yousef-main.jpg',
  siteUrl: 'https://portfolio--yousef.vercel.app',
};
